import { BASE_PATH, BASE_PATH_EXTENSION_ADMIN } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}/tickets`;

export async function searchTickets() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/search`, config)
}

export async function addTickets(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}
